var path = '/pages/contacts/directives/sections/picklists/contact-picklists.tpl.html';
var html = "<section ng-if=\"vm.show && (vm.error || vm.picklists.length > 0)\">\n    <h2>Picklists</h2>\n    <div class=\"content-box box-900\">\n        <div class=\"box-section-wrap\">\n            <span class=\"msg error-msg\" ng-if=\"vm.error\">{{vm.error}}</span>\n            <span ng-repeat=\"picklist in vm.picklists\">\n                <a ng-click=\"vm.goToPicklist(picklist)\">{{picklist.name}}</a><span ng-if=\"!$last\">&nbsp;&nbsp;|&nbsp;&nbsp;</span></span>\n        </div>\n    </div>\n</section>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/directives/sections/picklists/contact-picklists.tpl.html
// module id = 2224
// module chunks = 1